export default "__VITE_ASSET__329b5806__"